<template lang="html">
    <el-popover
        :content="text"
        trigger="hover">
        <el-button
            slot="reference"
            type="text"
            icon="el-icon-question"
            circle>
        </el-button>
    </el-popover>
</template>

<script>
export default {
    name: 'FormHelp',
    props: {
        text: {
            type: String,
            required: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/ui/FormHelp.vue